import { Spinner, Typography } from '@material-tailwind/react'
import { Cell, Row } from '@table-library/react-table-library'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const LoadingRow = ({ gridColumnStart, gridColumnEnd }) => {
  const { t } = useTranslation()
  return (
    <Row>
      <Cell
        gridColumnStart={gridColumnStart}
        gridColumnEnd={gridColumnEnd}
        className='flex flex-col'
      >

        <Spinner className='mr-4' />
        <Typography>{t('table.loading')}</Typography>
      </Cell>
    </Row>
  )
}

LoadingRow.defaultProps = {
  gridColumnStart: 1,
  gridColumnEnd: 3
}

LoadingRow.propTypes = {
  gridColumnStart: PropTypes.number,
  gridColumnEnd: PropTypes.number
}
